<template>
  <div class="app-container">
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm">
      <el-form-item label="姓名" prop="name" style="width: 50%">
        <el-input v-model="ruleForm.name" maxlength="10" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="mobile" style="width: 50%">
        <el-input v-model="ruleForm.mobile"></el-input>
      </el-form-item>
      <el-form-item label="账号" prop="account" style="width: 50%">
        <el-input v-model="ruleForm.account"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password" style="width: 50%" :required="!ruleForm.uuid">
        <el-input v-model="ruleForm.password"></el-input>
      </el-form-item>

      <el-form-item label="上传头像" prop="avatar">
        <imgUpload v-model="ruleForm.avatar"></imgUpload>
      </el-form-item>

      <el-form-item label="所属校区" prop="school_uuid">
        <el-select v-model="ruleForm.school_uuid">
          <el-option v-for="item in schoolList" :key="item.uuid" :label="item.title" :value="item.uuid"></el-option>
        </el-select>
        <!-- <el-tag>+</el-tag> -->
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
        <el-button @click="$router.go(-1)">取消</el-button>
      </el-form-item>
    </el-form>

    <!-- <el-dialog title="收货地址" :visible.sync="dialogTableVisible">
          <el-table :data="gridData">
            <el-table-column property="date" label="日期" width="150"></el-table-column>
            <el-table-column property="name" label="姓名" width="200"></el-table-column>
            <el-table-column property="address" label="地址"></el-table-column>
          </el-table>
        </el-dialog> -->
  </div>
</template>

<script>
import imgUpload from "@/components/pub/imgUploadNormal.vue";
import fullEdit from "@/components/pub/fulledit.vue";
import { addTeacher, teacherDetail, editTeacher } from "@/api/teacher.js";
import { getSchoolList } from "@/api/school.js";
export default {
  components: {
    imgUpload,
    fullEdit,
  },
  data() {
    const phoneRules = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入手机号码"));
      } else {
        const reg = /^1[3|4|5|6|7|8][0-9]\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    const validPassword = (rule, value, callback) => {
      if (!value) {
        callback();
      }
      // const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/
      const reg = /^[A-Za-z0-9]{6,16}$/;
      if (!reg.test(value)) {
        callback(new Error("密码为6-16位数字或字母"));
      } else {
        callback();
      }
    };
    const validAccount = (rule, value, callback) => {
      const reg = /^[A-Za-z0-9]+$/;
      if (!reg.test(value)) {
        callback(new Error("账号支持数字、英文"));
      } else {
        callback();
      }
    };
    return {
      schoolList: [],
      query: this.$route.query,
      ruleForm: {
        type: 2,
        group_id: 927,
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入教师名称",
            trigger: "blur",
          },
        ],
        account: [
          { required: true, message: "请输入账号", trigger: "blur" },
          { validator: validAccount, trigger: "blur" },
        ],
        mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          { validator: phoneRules, trigger: "blur" },
        ],
        password: [{ validator: validPassword, trigger: "blur" }],
        avatar: [
          {
            required: true,
            message: "请上传头像",
            trigger: "change",
          },
        ],
      },
    };
  },
  mounted() {
    if (this.$route.query.uuid) {
      this.getDetail(this.$route.query.uuid);
    }
    this.getSchool();
  },
  methods: {
    async getSchool() {
      const res = await getSchoolList({ status: 1 });
      if (res.data instanceof Array) {
        this.schoolList = res.data;
      }
      console.log(res);
    },
    async getDetail(uuid) {
      const res = await teacherDetail(uuid);
      if (res) {
        this.ruleForm = res;
        this.ruleForm.account = res.admin ? res.admin.account : "";
      }

      console.log(res);
    },
    async subEdit() {
      const res = await editTeacher(this.ruleForm, this.query.uuid);
      if (res) {
        this.$message.success("成功");
        this.$router.go(-1);
      }
    },
    async subAdd() {
      const res = await addTeacher(this.ruleForm);
      if (res) {
        this.$message.success("成功");
        this.$router.go(-1);
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.query.uuid) {
            this.subEdit();
          } else {
            this.subAdd();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style></style>
